import Component from 'vue-class-component';
import { AppVue } from '../../app.vue';
import { Header } from './header/header';
import { Menu } from './menu/menu';
import './platform.scss';

@Component({
    template: require('./platform.html'),
    name: 'PagePlatform',
    components: {
        'md-menu': Menu,
        'md-header': Header
    },
    props: {
        platformMenu: {
            type: Array,
        },
    },
})
export class PagePlatform extends AppVue {
    created() {
        console.log('PagePlatform++++++++++++');
        return {};
    }
}